var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapContainer"},[_c('div',{ref:"map",staticClass:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"measure",on:{"click":_vm.toMeasure}})])
}
var staticRenderFns = []

export { render, staticRenderFns }